export enum FDFTUXType {
  TRADITIONAL_FDs = 'TRADITIONAL_FDs',
  BONDS_DEBT_MFs = 'BONDS_DEBT_MFs',
  EQUITY = 'EQUITY'
}

type BaseElement = {
  className?: string
  maxWidth?: string
  inlineStyles?: React.CSSProperties
}

export interface TextElement extends BaseElement {
  type: 'TEXT'
  text: string
}

export interface ImageElement extends BaseElement {
  type: 'IMAGE'
  imgSrc: string
}

export interface ChevronBoxElement extends BaseElement {
  type: 'CHEVRON_BOX'
  imgSrc: string
  text: string
  title?: string
  isActionable?: boolean
}

export interface RadioBoxElement extends BaseElement {
  type: 'RADIO_BOX'
  imgSrc?: string
  text: string
  title?: string
}

export type FTUXElementType = TextElement | ImageElement | ChevronBoxElement | RadioBoxElement

export type FTUXType = FTUXElementType[][]

export type FTUXConfigType = {
  [x in `${FDFTUXType}`]: FTUXType
}

export enum FDIntentTypes {
  INVEST_NOW = 'Yes, invest now',
  CALLBACK = 'Request callback',
  INVEST_LATER = 'No, invest later'
}
